export default "__VITE_ASSET__DuH2NYEE__"